import './style.scss'
import { AppLabel, AppText, CustomContainer, ScreenContainer } from 'src/style'
import { teamAuditColumns, teamAuditData } from 'src/utils/tableLayout'
import utility from 'src/utils/utility'
import { Table } from 'src/component'


const TeamAudit: React.FC = () => {
    return (
        <>
            <ScreenContainer
                leftPadding='2.5' rightPadding='2.5'
                topPadding='1.5' bottomPadding='1.5'
            >
                <CustomContainer>
                    <AppLabel textSize='2' fontWeight='600' color='#181D27'>Manage team audit</AppLabel>
                    <AppText color='#6F767C' topMargin='0.7'>See what your team mates are doing.</AppText>
                </CustomContainer>

                <CustomContainer topMargin='6'>
                    <Table 
                        tableData={teamAuditData}
                        tableColumns={teamAuditColumns}
                        customStyle
                        canSearch
                        canDateSearch
                    />
                </CustomContainer>
            </ScreenContainer>
        </>
    )
}

export default utility.routeData('team-audit', 'Team Audit', <TeamAudit/>)